import React from "react"

const Banner = () => {
  return (
    <div className="banner">
      <div className="banner-figure">
        <h1>$100B+</h1>
        <span>Transactions completed</span>
      </div>

      <span>for</span>

      <div className="banner-figure">
        <h1>13+</h1>
        <span>Customers</span>
      </div>

      <span>across</span>

      <div className="banner-figure">
        <h1>40+</h1>
        <span>Countries</span>
      </div>
    </div>
  )
}

export default Banner
